import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";
import { CommonMessageWidget } from "@eforall/common";
import { AccApplicationStatusId, BlockoutSlots } from "@interfaces";
import { ScheduleViewerPart } from "../../schedule/schedule-viewer/schedule-viewer.part";
import { AccApplicationDialogDataService } from "../acc-application-dialog-data.service";

@Component({
	selector: 'acc-application-dialog-schedule-part',
	standalone: true,
	imports: [
		ScheduleViewerPart,
		CommonMessageWidget,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './schedule.part.html',

})
export class AccApplicationDialogSchedulePart {

	public readonly dialogDataService = inject(AccApplicationDialogDataService);

	readonly details = computed(() => this.dialogDataService.dialogData()?.details);

	readonly blockoutSlots = computed<BlockoutSlots[]>(() => {

		return this.dialogDataService.accWithScheduleSlots().filter(t => t.languageId === this.details()?.languageId).map(slot => ({
			dayIndex: slot.dayIndex,
			startTimeIndex: slot.startTimeIndex,
			applicantSelectedAccSlot: slot.applicantSelectedAccSlot,
		}));
	});

	readonly canEdit = computed(() => {
		const details = this.details();
		if (!details) return false;
		return ![AccApplicationStatusId.SeatOffered, AccApplicationStatusId.SeatAccepted, AccApplicationStatusId.InCohort].includes(details.accApplicationStatusId)
			&& !this.dialogDataService.isReadonly();
	});
}